/* eslint-disable */
export default {
  unknown: '不明',
  anonymous: '匿名',
  activeCall: 'アクティブな通話',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
